import { FC } from "react";
import { useLogout } from "../../hooks";

export const LogoutView: FC = () => {
  const logout = useLogout();
  void logout();
  return null;
  // return <Navigate to={authLocations.SignIn.buildPath({})} />;
};
